// extracted by mini-css-extract-plugin
export default {"erroritems":"NotFound_erroritems__KQ3Kr"};